export default __webpack_public_path__ + "assets/images/da3dfcf94471a11da7355cc55ac0be1e.svg";